import React, { FC } from 'react';

import { Container, Card, Text, Title } from './styles';

import useConnect from './connect';

const PaymentIssues: FC = () => {
  const { me } = useConnect();

  const hasDdIssues = !!me?.paymentIssues.find((platform) => platform === 'dd');
  const hasGhIssues = !!me?.paymentIssues.find((platform) => platform === 'gh');
  const hasFkOne = !!me?.paymentIssues.find((platform) => platform === 'fk');
  const showSummaty = hasDdIssues || hasGhIssues;

  return (
    <Container>
      <Card>
        <Title>Payment issues</Title>
        <Text>
          Unfortunately, due to ongoing delivery platform issues, your payments
          may be delayed. Our team has escalated this situation with all
          impacted platforms and as soon as we receive payments from the
          platforms, you will see a deposit to your account within 1-3 days.
        </Text>

        {showSummaty && (
          <>
            <Title>Summary of the Situation</Title>
            {/* (IF organization_core.payment_issues = yes for **DoorDash**) */}
            {hasDdIssues && (
              <Text>
                DoorDash`s payment processor is selectively flagging individual
                accounts as problematic and pausing payments, this does not
                affect all accounts. Once this is resolved, you will receive all
                backpay and current cycle pay following the standard payment
                cycle from Superorder.
              </Text>
            )}

            {/* (IF organization_core.payment_issues = yes for **Grubhub**) */}
            {hasGhIssues && (
              <Text>
                Grubhub’s process for setting up direct deposit when onboarding
                new accounts is currently experiencing outages, not only for
                Superorder but other customers and brands. Once this is
                resolved, you will receive all backpay and current cycle pay
                following the standard payment cycle from Superorder.
              </Text>
            )}
          </>
        )}

        <Title>What is Superorder doing?</Title>
        {/* (IF organization_core.payment_issues = yes for **DoorDash**) */}
        {hasDdIssues && (
          <Text>
            We have escalated this issue to a Sr Success Manager and our
            priority channel with DoorDash’s Merchant Experience Partner team to
            get it resolved ASAP.
          </Text>
        )}
        {/* (IF organization_core.payment_issues = yes for **Grubhub**) */}
        {hasGhIssues && (
          <Text>
            We have escalated this issue to our Senior Account Manager and the
            Direct Deposit team to get it resolved ASAP. If you receive a
            physical check from Grubhub, let us know and you have the option of
            depositing it, and we will redeposit to you.
          </Text>
        )}
        {/* (IF FK-One?) */}
        {hasFkOne && (
          <Text>
            We understand that cash flow is critical for restaurants such as
            yours. During this period, Superorder will pay out deposits out of
            our accounts, even before we have been paid by the platforms, to
            minimize disruptions to your business. Additionally, we will forego
            our standard fees as laid out in our business agreement.
          </Text>
        )}
        <Text>
          We apologize for this inconvenience and we will let you know as soon
          as a resolution is reached.
        </Text>
      </Card>
    </Container>
  );
};

export default PaymentIssues;
